import React from 'react';
import PropTypes from 'prop-types';

import { useContext } from '@hooks';
import { mergeClasses } from '@utils';

import { ButtonContext } from './Button';

export default function ButtonIcon({ children, className, ...restProps }) {
  useContext(ButtonContext, 'Button.Icon must be a child of Button');

  return (
    <span
      className={mergeClasses(
        'flex h-6 w-6 items-center justify-center fill-black',
        className
      )}
      {...restProps}
    >
      {React.Children.map(children, child => {
        if (React.isValidElement(child)) {
          return React.cloneElement(child, {
            className: mergeClasses(child.props.className, 'w-full h-full')
          });
        }

        throw new Error('Button.Icon children must be valid React elements');
      })}
    </span>
  );
}

ButtonIcon.propTypes = {
  children: PropTypes.node.isRequired,
  className: PropTypes.string
};

ButtonIcon.defaultProps = {
  className: ''
};
